import React, { useContext } from 'react';
import { IonButton, IonIcon, IonItem, IonLabel } from '@ionic/react';
import { LanguageContext } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  return (
    <IonItem onClick={() => setLanguage(language === 'it' ? 'en' : 'it')} lines="none" detail={false}>
        <IonIcon slot="start" icon={language === 'it' ? `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-en.svg` : `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-it.svg`} className="menuIcon" />
        <IonLabel>{language === 'it' ? 'English' : 'Italiano'}</IonLabel>
    </IonItem>
  );
};

export default LanguageSwitcher; 